import pagingWithFilteredResults from '@/constants/states';
import { readStates, updateStates } from '@/constants/lifecycle';
import { searchPermissions } from '../../constants';

export const searchPerms = (can = false) => {
  const permissions = {};
  Object.values(searchPermissions).forEach((permission) => {
    permissions[permission] = can;
  });
  return permissions;
};

export const searchPermsFromArray = (truePermissions = []) => {
  const permissions = searchPerms();

  truePermissions.forEach((permission) => {
    permissions[permission] = true;
  });

  return permissions;
};

export const newSearchMember = (member, permissions) => ({
  ...member,
  permissions: { ...permissions },
  selected: false,
});

export const searchMembers = (pageSize = 20, minFilterLength = 0, requiresFilter = false) => ({
  ...pagingWithFilteredResults(pageSize, minFilterLength, requiresFilter),
  original: [],
  ...readStates,
});

const sharingSearch = () => ({
  open: false,
  code: '',
  category: '',
  permissionGroup: 'OBSERVER',
  membersToAdd: [],
  ...updateStates,
});

export default sharingSearch;
